// Вопрос и ответ карточки хранятся как JSON-состояние редактора Lexical.
// В буфер обмена нужен текст, а не дерево узлов, поэтому дерево обходим здесь.

// Узлы-блоки заканчивают строку: без этого абзацы и пункты списка склеиваются
// в одну строку и скопированная карточка становится нечитаемой.
const BLOCK_NODE_TYPES = new Set(['paragraph', 'heading', 'quote', 'listitem']);

const nodeToPlainText = (node) => {
    if (!node || typeof node !== 'object') {
        return '';
    }

    if (node.type === 'linebreak') {
        return '\n';
    }

    if (typeof node.text === 'string') {
        return node.text;
    }

    const childrenText = Array.isArray(node.children)
        ? node.children.map(nodeToPlainText).join('')
        : '';

    return BLOCK_NODE_TYPES.has(node.type) ? `${childrenText}\n` : childrenText;
};

/**
 * Текст из содержимого RichTextEditor.
 * @param {string} content JSON-состояние Lexical
 * @returns {string} текст без разметки
 */
export const richTextToPlainText = (content) => {
    if (typeof content !== 'string' || content.trim() === '') {
        return '';
    }

    let editorState;
    try {
        editorState = JSON.parse(content);
    } catch (error) {
        // Не JSON — значит, в поле лежит обычный текст (старые карточки, ручной
        // импорт). Отдаём как есть: это лучше, чем пустой буфер обмена.
        return content;
    }

    return nodeToPlainText(editorState?.root).trim();
};

export default richTextToPlainText;
